<template>
  <div class="users" v-if="users && !$store.state.ui.preloaderStatus">
    <data-table
      header-icon="users-apioshade3"
      header-text="Users"
      :headers="fields"
      :items="users"
      :loaded="loaded"
    >
      <div
        slot="activator"
        v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"
        ><apio-button
          button-size="small"
          button-text-size="tiny"
          @click.native="addUser"
          >NEW
          <apio-icon
            class="ml-1"
            name="ui-user-new"
            lightModeColour="white"
            darkModeColour="white"
            size="24" /></apio-button
          ></div
      >
      <div slot="add" v-else
        ><apio-button
          @click.native="addUser"
          >New
          <apio-icon
            class="ml-1"
            name="ui-user-new"
            lightModeColour="white"
            darkModeColour="white"
            size="32" /></apio-button
      ></div>
      <template v-slot:[`item.show_details`]="{ item }">
        <div
          style="display: flex; justify-content: flex-end; cursor: pointer;"
          :ripple="false"
          @click="toggleDialog(true, 'edit', item)"
        >
          <apio-icon name="ui-edit"></apio-icon>
        </div>
      </template>

      <template v-slot:[`item.md_clients`]="{ item }">
        <v-chip
          v-for="client in item.md_clients"
          class="mr-1"
          small
          label
          :key="client"
          color="primary"
          >{{ client === "*" ? "All" : clientName(client) }}</v-chip
        >
      </template>

      <div slot="actions" class="users__permissions-legend">
        <span class="small-extra-bold">BUILD</span><apio-icon class="ml-1" name="ui-app-new" lightModeColour="purple" darkModeColour="purple" size="16" /><span class="ml-4 small-extra-bold">ADMIN</span>
        <apio-icon class="ml-1" name="ui-admin" lightModeColour="purple" darkModeColour="purple" size="16" />
      </div>
    </data-table>

    <p v-if="loaded && !users" class="organisations__no-results">There are no users</p>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <user-form
        @toggleDialog="toggleDialog"
        v-if="modalMode === 'edit'"
        :title="modalMode === 'add' ? 'Add new user' : 'Edit user'"
        :user-data="edituser"
        :clients="clientsDetails"
        mode="edit"
      />
      <user-form
        @toggleDialog="toggleDialog"
        v-else
        :title="modalMode === 'add' ? 'Add new user' : 'Edit user'"
        :user-data="newuser"
        :clients="clientsDetails"
        mode="new"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Users",
  components: {
    UserForm: () => import("@/components/Users/UserForm.vue"),
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
  },
  data: () => ({
    loaded: false,
    search: "",
    searchTerm: "",
    dialog: "",
    modalStatus: false,
    modalMode: "",
    addShowing: false,
    edituser: {},
    headerText: "Users",
    newuser: { clients: {} },
    tableSearchIcon: "fa-search",
    fields: [
      {
        value: "email",
        text: "Email",
      },
      {
        value: "fullname",
        text: "Full Name",
      },
      {
        value: "source",
        text: "Source",
      },
      {
        value: "md_clients",
        text: "Organisations",
      },
      {
        value: "show_details",
        text: "",
      },
    ],
  }),
  mounted() {
    this.$on("toggleDialog", (value) => this.toggleDialog(value));
  },
  computed: {
    ...mapState({
      users: (state) => state.users.users,
      clients: (state) => state.users.clients,
      clientsDetails: (state) => state.users.clientsDetails,
    }),
    noUsers() {
      return !this.users || !this.users.length;
    },
  },
  methods: {
    clientName(clientHash) {
      if(!this.clientsDetails) return;
      const client = this.clientsDetails.filter((client) => client.ID === clientHash);
      if(client[0]) return client[0].name
    },
    toggleDialog(value, modalMode, item) {
      this.edituser = item;
      this.dialog = value;
      this.modalMode = modalMode;
    },
    filter(searchTerm) {
      this.search = searchTerm;
      this.$emit("filter", this.searchTerm);
    },
    addUser() {
      this.$router.push("/users/add");
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.$store.dispatch("fetchUsers", vm.$route.query.c);
      vm.loaded = true;
    })
  },
};
</script>

<style lang="scss" scoped>
.users {
  color: var(--apio-shade-2);
  margin-top: 8px;

  &__permissions-legend {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
  }

  &__add-button {
    margin: 0 12px;
    width: 32px;
    height: 32px;
    display: flex;

    &--mobile {
      background: var(--apio-cyan);
      background-size: cover;
      border-radius: 50%;
      margin: 0 12px;
      height: 32px;
      width: 32px;
      position: relative;

      & > .icon-24.grunticon__icon-ui-plus-white {
        position: relative;
        top: 4px;
        left: 4px;
      }
    }

    &--mobile:hover {
      cursor: pointer;
    }
  }
}

@media (min-width: 769px) {
  .users {
    &__add-button {
      margin: 0 12px;
      width: fit-content;
      height: 48px;
    }
  }
}
</style>
